export const Roles = Object.freeze({
  ROLE_EDITEUR: 'Editeur',
  ROLE_ADMIN: 'Admin',
  ROLE_UTILISATEUR: 'Utilisateur',
  ROLE_VISITEUR: 'Visiteur'
})



// WEBPACK FOOTER //
// ./src/utils.js